module.exports = __webpack_public_path__ + "img/about/80243-003.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-003.png
// module id = 13
// module chunks = 0